import '../css/candidatos-frontend.css';

document.addEventListener('DOMContentLoaded', () => {
    // Resetear paginación al enviar filtros
    const form = document.querySelector('.pp-candidatos-filtros');
    if (form) {
        form.addEventListener('submit', () => {
            const paged = form.querySelector('input[name="paged"]');
            if (paged) {
                paged.remove();
            }
        });
    }

    function abrirModal(index) {
        const modal = document.getElementById(`pp-modal-${index}`);
        if (modal) {
            modal.hidden = false;
            const botonCerrar = modal.querySelector('.pp-modal-close');
            if (botonCerrar) {
                botonCerrar.focus();
            }
            document.body.style.overflow = 'hidden';
        }
    }

    function cerrarModal(modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
    }

    // Abrir modal al clicar o pulsar Enter en una tarjeta
    document.addEventListener('click', (e) => {
        const card = e.target.closest('.pp-candidato-card');
        if (card) {
            abrirModal(card.dataset.index);
            return;
        }
        const closeBtn = e.target.closest('.pp-modal-close');
        if (closeBtn) {
            cerrarModal(closeBtn.closest('.pp-candidato-modal'));
            return;
        }
        if (e.target.classList.contains('pp-candidato-modal')) {
            cerrarModal(e.target);
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            const card = e.target.closest('.pp-candidato-card');
            if (card) {
                e.preventDefault();
                abrirModal(card.dataset.index);
            }
        }
        if (e.key === 'Escape') {
            document.querySelectorAll('.pp-candidato-modal:not([hidden])').forEach(cerrarModal);
        }
    });
});
